export default __webpack_public_path__ + "static/media/Techno Pak.4efe150d.png";